import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Map as MapIcon, Radio, Car, AlertTriangle, Menu, LogOut} from 'lucide-react';
import './MainLayout.css';

const MainLayout = ({ children, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // 1. Logic การหา Active Module (กัน Error กรณี path ว่าง)
  const currentPath = location.pathname.split('/')[1] || 'dashboard';
  const [activeModule, setActiveModule] = useState(currentPath);

  useEffect(() => {
    // ถ้า path เป็น 'simulation' (กรณี uncomment) ก็จะทำงานได้ถูกต้อง
    setActiveModule(currentPath);
  }, [currentPath]);

  const topMenu = [
    { id: 'dashboard', label: 'DASHBOARD', icon: LayoutDashboard, path: '/dashboard' },
    { id: 'map', label: 'MAP', icon: MapIcon, path: '/map' }, 
    { id: 'rsu', label: 'RSU', icon: Radio, path: '/rsu' },
    { id: 'obu', label: 'OBU', icon: Car, path: '/obu' }, // แก้ตรงนี้ให้ตรงกับ subMenus
    { id: 'event', label: 'EVENT', icon: AlertTriangle, path: '/event' },
  ];

  const subMenus = {
    dashboard: [
      { label: 'Overview', path: '/dashboard' },
      // { label: 'Analytics', path: '/dashboard/analytics' } // ตัวอย่าง
    ],
    map: [
      { label: 'Live View', path: '/map' },
      // { label: 'Heatmap', path: '/map/heat' }
    ],
  
    rsu: [
      { label: 'All Units', path: '/rsu' },
      // { label: 'Add New', path: '/rsu/new' }
    ],
    obu: [ // 2. แก้จาก 'obs' เป็น 'obu' ให้ตรงกับ id ด้านบน
      { label: 'All Vehicles', path: '/obu' }
    ],
    event: [
      { label: 'Event Logs', path: '/event' }
    ]
  };

  const handleLogoutClick = () => {
    if(window.confirm("Are you sure you want to logout?")) {
      onLogout(); 
      navigate('/login');
    }
  };

  const handleTopNavClick = (menu) => {
    setActiveModule(menu.id);
    navigate(menu.path);
  };

  return (
    <div className="layout-container">
      {/* --- SIDEBAR --- */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <Menu size={20} />
          {/* ป้องกัน error ถ้า activeModule หาไม่เจอ */}
          <span>{(activeModule || 'V2X').toUpperCase()}</span>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {(subMenus[activeModule] || []).map((sub, idx) => (
              <li key={idx}>
                <button 
                  onClick={() => navigate(sub.path)} 
                  // 3. เพิ่ม logic เช็ค active ให้ปุ่ม sidebar
                  className={`sidebar-link ${location.pathname === sub.path ? 'active' : ''}`}
                >
                  {sub.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* ปุ่ม Logout */}
        <div className="sidebar-footer">
          <button onClick={handleLogoutClick} className="logout-btn">
            <LogOut size={20} />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* --- MAIN WRAPPER --- */}
      <div className="main-wrapper">
        {/* TOP HEADER */}
        <header className="top-header">
          <div className="header-brand">V2X System</div>
          
          <div className="header-menu">
            {topMenu.map((item) => (
              <button
                key={item.id}
                onClick={() => handleTopNavClick(item)}
                className={`header-link ${activeModule === item.id ? 'active' : ''}`}
              >
                <item.icon size={18} />
                <span>{item.label}</span>
              </button>
            ))}
          </div>

          {/* 4. พื้นที่สำหรับ Google Translate (ถ้ามี) */}
          <div style={{ marginLeft: 'auto', paddingRight: '20px' }}>
             {/* <div id="google_translate_element"></div> */}
          </div>
        </header>

        {/* CONTENT */}
        <main className="page-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;